import { render } from "./AgendaSettingForm.vue?vue&type=template&id=2c286dc6"
import script from "./AgendaSettingForm.vue?vue&type=script&lang=js"
export * from "./AgendaSettingForm.vue?vue&type=script&lang=js"

import "./AgendaSettingForm.vue?vue&type=style&index=0&id=2c286dc6&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__